import { isValidElement } from "react";
import { toast as sonnerToast } from "sonner";
import { formatApiErrorDetail } from "@/lib/apiClient";

// Consistent, render-safe error notifications without mutating the vendor API.
export const toast = Object.assign((...args) => sonnerToast(...args), sonnerToast, {
  error: (message, options) => sonnerToast.error(isValidElement(message) ? message : formatApiErrorDetail(message), options),
});